import { merge } from "lodash";
import { ElementDefinition, ShowElement } from "@easy-email-pro-core/typings";
import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import { createBlock, t } from "@easy-email-pro-core/utils";
import React from "react";
import { PluginManager } from "@easy-email-pro-core/utils/plugins/PluginManager";

const defaultData: ElementDefinition<ShowElement>["defaultData"] = {
  attributes: {},
  data: {
    showTruthyInTesting: true,
    expression: "",
    component: <></>,
  },
};

export const Show = createBlock<ShowElement>({
  get name() {
    return t("Show");
  },
  type: ElementType.FOR_EACH,
  category: ElementCategory.UNSET,
  defaultData,
  create(payload) {
    const data: ShowElement = {
      type: ElementType.SHOW,
      data: {
        ...defaultData.data,
      },
      attributes: {
        ...defaultData.attributes,
      },
      children: [],
    };
    return merge(data, payload);
  },
  render(params) {
    const { node, mode } = params;
    const data = node.data;

    if (mode === "testing") {
      if (data.showTruthyInTesting) {
        return <>{data.component}</>;
      } else {
        return <>{data.fallback}</>;
      }
    }

    const renderContent = PluginManager.generateConditionTemplate(
      data.expression,
      data.component,
      data.fallback
    );

    return renderContent;
  },
});
